/* so-cart-source — P0-12 "one line per flavour" (2026-09-28).
   Where a cart line came from lives in ONE hidden cart attribute, `_so_src`, never in line properties, so the
   same variant always stays ONE line (Shopify only merges lines whose properties are identical).
   Value: ",<variantId>:<source>:<via>:<units>,…"  e.g. ",4411:cart-upsell::1,5522:quick-add:collection:2,"
     source  quick-add | cart-upsell | cart-usual | cart-popular | cart-reorder | your-picks
     via     quick-add: collection|home|search|product-recs|page|other; your-picks: the link's src/utm; else ''
     units   how many of that variant's line units this source put there (never more than the line holds)
   Units no entry covers came from the product page / sticky bar / FBT / bundles (untagged, as before).
   Leading underscore = hidden from the shopper at checkout; carried to the order (Admin customAttributes).
   Readers: snippets/so-cart-addons.liquid, assets/so-for-you.js, scripts/quick_add_report.py.
   Writes: /cart/update.js {attributes:{_so_src}} MERGES attributes, so _so_delivery / _so_r / Preorder /
   Age check are never touched. One flush at a time; failures are swallowed (attribution never blocks the cart).
   Simplified 2026-09-28 (Charl): _so_src is a BEST-EFFORT UI HINT for the Liquid upsell rule only — nothing
   relies on it reaching the order, checkout is never touched (no click hold, no fetch wrapper); measuring
   where adds come from moves to GA4 events (P0-13).
   Pure helpers are exported for node tests (tests/theme/unit/so-cart-source.test.mjs). */
(function (root, factory) {
  var node = typeof window === 'undefined' && typeof module === 'object' && module.exports;
  var api = factory();
  if (node) module.exports = api;
  else { root.SO = root.SO || {}; root.SO.cartSource = api; api._boot(root); }
})(typeof self !== 'undefined' ? self : this, function () {
  var KEY = '_so_src', MAX_LEN = 1000;
  var WORD = /^[a-z0-9-]{1,24}$/;

  function clean(s) { s = String(s == null ? '' : s).toLowerCase(); return WORD.test(s) ? s : ''; }
  function copy(e) { return { id: e.id, source: e.source, via: e.via, units: e.units }; }

  function parse(value) {
    var out = [];
    String(value || '').split(',').forEach(function (part) {
      var f = part.split(':');
      if (f.length !== 4) return;
      var id = Number(f[0]), n = Number(f[3]);
      if (!(id > 0) || !(n > 0) || Math.floor(n) !== n || !WORD.test(f[1])) return;
      if (f[2] !== '' && !WORD.test(f[2])) return;
      out.push({ id: id, source: f[1], via: f[2], units: n });
    });
    return out;
  }
  function format(entries) {
    if (!entries || !entries.length) return '';
    return ',' + entries.map(function (e) { return e.id + ':' + e.source + ':' + e.via + ':' + e.units; }).join(',') + ',';
  }
  // Only variants still in the cart; per variant never more units than the line holds (oldest entries keep
  // theirs, the newest gives way); the value stays within MAX_LEN (oldest entries dropped first).
  function prune(entries, qty) {
    var left = {}, keep = [];
    Object.keys(qty || {}).forEach(function (k) { left[k] = Number(qty[k]) || 0; });
    entries.forEach(function (e) {
      var l = left[e.id] || 0, n = Math.min(e.units, l);
      if (n > 0) { keep.push({ id: e.id, source: e.source, via: e.via, units: n }); left[e.id] = l - n; }
    });
    while (keep.length && format(keep).length > MAX_LEN) keep.shift();
    return keep;
  }
  function add(entries, id, source, via, units) {
    id = Number(id); source = clean(source); via = clean(via); units = Math.floor(Number(units) || 0);
    var out = entries.map(copy);
    if (!(id > 0) || !source || !(units > 0)) return out;
    var hit = null;
    out.forEach(function (e) { if (e.id === id && e.source === source && e.via === via) hit = e; });
    if (hit) hit.units += units; else out.push({ id: id, source: source, via: via, units: units });
    return out;
  }
  // your-picks "press again = SET": this source's share of the variant becomes exactly `units`.
  function setUnits(entries, id, source, via, units) {
    id = Number(id); source = clean(source); via = clean(via); units = Math.max(0, Math.floor(Number(units) || 0));
    var out = entries.filter(function (e) { return !(e.id === id && e.source === source); }).map(copy);
    if (id > 0 && source && units > 0) out.push({ id: id, source: source, via: via, units: units });
    return out;
  }
  // Cart "Change": the line's attribution follows it to the new flavour (merged with what that flavour had).
  function move(entries, fromId, toId) {
    fromId = Number(fromId); toId = Number(toId);
    var out = entries.filter(function (e) { return e.id !== fromId; }).map(copy);
    entries.forEach(function (e) {
      if (e.id !== fromId) return;
      var hit = null;
      out.forEach(function (x) { if (x.id === toId && x.source === e.source && x.via === e.via) hit = x; });
      if (hit) hit.units += e.units; else out.push({ id: toId, source: e.source, via: e.via, units: e.units });
    });
    return out;
  }
  function unitsFor(entries, id, source) {
    id = Number(id);
    return entries.reduce(function (s, e) { return s + (e.id === id && e.source === source ? e.units : 0); }, 0);
  }
  function cartQty(cart) {
    var m = {};
    ((cart && cart.items) || []).forEach(function (l) { var id = Number(l.variant_id); m[id] = (m[id] || 0) + (Number(l.quantity) || 0); });
    return m;
  }

  // ---- legacy carts (pre-P0-12 lines tagged _source/_via) — Task 5, DL8 --------------------------
  var LEGACY = ['_source', '_via'];
  function byKey(a, b) { return a.key < b.key ? -1 : a.key > b.key ? 1 : 0; }
  // nodes = Storefront cart lines. Groups by variant + non-legacy attributes; a group with any tagged line
  // becomes ONE line (the largest keeps its place, gets the total, loses _source/_via; the rest go to 0).
  // records: legacy units per (variant, source, via), applied with atLeast() so a retry never double-counts.
  function migrationPlan(nodes) {
    var groups = {}, order = [], records = [];
    (nodes || []).forEach(function (n) {
      var a = {}, keep = [];
      (n.attributes || []).forEach(function (x) { a[x.key] = x.value; if (LEGACY.indexOf(x.key) === -1) keep.push({ key: x.key, value: x.value }); });
      var vid = Number(String(n.merchandise && n.merchandise.id).split('/').pop());
      if (a._source) {
        var rk = vid + ':' + a._source + ':' + (a._via || ''), hit = null;
        records.forEach(function (x) { if (x.k === rk) hit = x; });
        if (hit) hit.units += n.quantity;
        else records.push({ k: rk, id: vid, source: String(a._source), via: String(a._via || ''), units: n.quantity });
      }
      var k = vid + '|' + JSON.stringify(keep.slice().sort(byKey));
      if (!groups[k]) { groups[k] = { keep: keep, lines: [] }; order.push(k); }
      groups[k].lines.push({ n: n, tagged: !!(a._source || a._via) });
    });
    var lines = [];
    order.forEach(function (k) {
      var g = groups[k];
      if (!g.lines.some(function (l) { return l.tagged; })) return;
      var total = g.lines.reduce(function (s, l) { return s + l.n.quantity; }, 0);
      var big = g.lines.reduce(function (b, l) { return l.n.quantity > b.n.quantity ? l : b; }, g.lines[0]);
      lines.push({ id: big.n.id, quantity: total, attributes: g.keep });
      g.lines.forEach(function (l) { if (l !== big) lines.push({ id: l.n.id, quantity: 0 }); });
    });
    return { lines: lines, records: records.map(function (x) { return { id: x.id, source: x.source, via: x.via, units: x.units }; }) };
  }
  // SET-style (review I3): the (variant, source, via) entry holds at least `units`; never lowered, never added twice.
  function atLeast(entries, id, source, via, units) {
    id = Number(id); source = clean(source); via = clean(via); units = Math.floor(Number(units) || 0);
    var out = entries.map(copy), hit = null;
    if (!(id > 0) || !source || !(units > 0)) return out;
    out.forEach(function (e) { if (e.id === id && e.source === source && e.via === via) hit = e; });
    if (hit) hit.units = Math.max(hit.units, units); else out.push({ id: id, source: source, via: via, units: units });
    return out;
  }

  // ---- browser: one queued read-modify-write at a time ----------------------------------------
  // Plain global fetch, looked up at call time (node unit tests stub it). Nothing on the page is wrapped.
  var queue = [], running = null, known = null;   // known: last _so_src value seen ('' = nothing to prune)
  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw r.status; return r.json(); });
  }
  // Review I1: take the ops BEFORE reading the cart. Every recorder calls record() only after its add
  // succeeded, so each op taken here is reflected in the snapshot; an op queued during the read waits
  // for the next read (pump loops), so prune can never drop the entry it was asked to record.
  function flushOnce() {
    var ops = queue.splice(0);
    return getCart().then(function (cart) {
      var had = (cart.attributes && cart.attributes[KEY]) || '';
      var entries = parse(had);
      ops.forEach(function (op) { entries = op(entries); });
      var next = format(prune(entries, cartQty(cart)));
      known = next;
      if (next === had) return;
      var attrs = {}; attrs[KEY] = next;
      return fetch('/cart/update.js', {
        method: 'POST', credentials: 'same-origin', keepalive: true,
        headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: attrs })
      });
    }).catch(function () { /* best-effort: attribution never blocks or breaks the cart */ });
  }
  function pump() {
    return flushOnce().then(function () {
      if (queue.length) return pump();
      running = null;
    });
  }
  function enqueue(op) {
    queue.push(op);
    if (!running) running = pump();
    return running;
  }

  // ---- legacy merge (Task 5, DL8): browser part -----------------------------------------------
  // Public Storefront token — the same one so-cart-addons.js ("Change") and sections/so-for-you.liquid use.
  var SF_TOKEN = '9f1a3cff0634491b892a6132ddc958c1';
  function sf(query, variables) {
    return fetch('/api/2025-07/graphql.json', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': SF_TOKEN },
      body: JSON.stringify({ query: query, variables: variables })
    }).then(function (r) { return r.json(); }).then(function (d) {
      if (d.errors && d.errors.length) throw d.errors[0].message;
      return d.data;
    });
  }
  function cartToken() {
    var m = document.cookie.match(/(?:^|; )cart=([^;]+)/);
    if (m) return Promise.resolve(decodeURIComponent(m[1]));
    return getCart().then(function (c) { return c.token; });
  }
  function refreshCart() {
    var cd = document.querySelector('cart-drawer');
    if (cd && typeof cd.refresh === 'function') cd.refresh(true);
    var main = Array.prototype.filter.call(document.querySelectorAll('cart-items'), function (x) { return !x.closest('cart-drawer'); })[0];
    if (main && typeof main.refresh === 'function') main.refresh();
  }
  // One-time merge (DL8): attribution first (so it can't be lost), then ONE cartLinesUpdate. At most 2 tries per
  // cart per tab; a failure leaves the cart working (just split) and the next page load retries.
  function migrate() {
    return cartToken().then(function (token) {
      var mark = 'soSrcMigrate:' + String(token).split('?')[0], tries = 0;
      try { tries = Number(sessionStorage.getItem(mark)) || 0; sessionStorage.setItem(mark, String(tries + 1)); } catch (e) { /* storage blocked: still bounded by the Liquid flag */ }
      if (tries >= 2) return null;
      var cartId = 'gid://shopify/Cart/' + token;
      return sf('query($id:ID!){cart(id:$id){lines(first:100){nodes{id quantity attributes{key value} merchandise{... on ProductVariant{id}}}}}}', { id: cartId })
        .then(function (d) {
          var plan = migrationPlan(d.cart ? d.cart.lines.nodes : []);
          if (!plan.lines.length) return null;
          plan.records.forEach(function (r) { enqueue(function (e) { return atLeast(e, r.id, r.source, r.via, r.units); }); });
          return (running || Promise.resolve()).then(function () {
            return sf('mutation($id:ID!,$lines:[CartLineUpdateInput!]!){cartLinesUpdate(cartId:$id,lines:$lines){userErrors{message} warnings{code message}}}', { id: cartId, lines: plan.lines });
          }).then(function (res) {
            var errs = res.cartLinesUpdate.userErrors;
            if (errs.length) throw errs[0].message;
            // Review M1: a stock clamp comes back as a warning after the fact; log it (the total was unchanged).
            (res.cartLinesUpdate.warnings || []).forEach(function (w) { if (window.console) console.warn('so-cart-source merge:', w.code, w.message); });
            refreshCart();
          });
        });
    }).catch(function () { /* the cart still works with split lines */ });
  }

  // Review I2 (simplified 2026-09-28): prune whenever the cart is shown or re-drawn — the /cart page, the drawer
  // opening, and the theme's own on:line-item:change after a drawer/cart-page −/remove — plus on every one of our
  // own writes (flushOnce prunes). No fetch/XHR wrapping. Debounced 1 s; nothing while _so_src is known empty.
  var tidyTimer = null;
  function tidy() {
    if (known === '') return;
    clearTimeout(tidyTimer);
    tidyTimer = setTimeout(function () { enqueue(function (e) { return e; }); }, 1000);
  }

  var api = {
    KEY: KEY, MAX_LEN: MAX_LEN,
    parse: parse, format: format, prune: prune, add: add, setUnits: setUnits, move: move, unitsFor: unitsFor, cartQty: cartQty,
    migrationPlan: migrationPlan, atLeast: atLeast, migrate: migrate,
    record: function (id, source, via, units) { return enqueue(function (e) { return add(e, id, source, via, units); }); },
    set: function (id, source, via, units) { return enqueue(function (e) { return setUnits(e, id, source, via, units); }); },
    moveTo: function (fromId, toId) { return enqueue(function (e) { return move(e, fromId, toId); }); },
    // Resolves when nothing is pending (immediately when idle). Tests and callers may await it.
    flush: function () { return running || Promise.resolve(); },
    pending: function () { return !!running; },
    _boot: function (win) {
      var doc = win.document, s = doc && doc.currentScript;
      known = s && s.hasAttribute('data-so-src-has') ? null : '';
      // Cart shown: the /cart page, the drawer each time it opens, and a drawer / cart-page re-draw after the
      // shopper's own −/remove (cart-items.js fires on:line-item:change once it has re-rendered). Listen only.
      if (win.location.pathname === '/cart') tidy();
      doc.addEventListener('on:line-item:change', tidy);
      var cd = doc.querySelector('cart-drawer');
      if (cd && win.MutationObserver) {
        new win.MutationObserver(function () { if (cd.getAttribute('aria-hidden') === 'false') tidy(); })
          .observe(cd, { attributes: true, attributeFilter: ['aria-hidden'] });
      }
      // Task 5 / DL8: a cart still holding pre-P0-12 tagged lines merges them once.
      // Review M2: only once the tab is visible (a background tab never rewrites line keys under the shopper).
      if (s && s.hasAttribute('data-so-src-legacy')) {
        if (doc.visibilityState === 'visible') migrate();
        else doc.addEventListener('visibilitychange', function once() {
          if (doc.visibilityState !== 'visible') return;
          doc.removeEventListener('visibilitychange', once); migrate();
        });
      }
    }
  };
  return api;
});
